import { Card } from '@ipfabric/ui-components/Card/Card';
import { SidePanel } from '@ipfabric/ui-components/SidePanel/SidePanel';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import { useLocale } from 'containers/App/LocaleContext';
import { UserProfile } from 'pages/Me/UserProfile/UserProfile';
import {
  type EditedUser,
  LocalUserForm,
} from 'pages/Settings/Administration/LocalUsers/LocalUserForm';
import { UpdatePasswordForm } from 'pages/Settings/Administration/LocalUsers/UpdatePasswordForm';
import type { FC } from 'react';

type Props = {
  editedUser: EditedUser | 'new';
  onClose: () => void;
  onSaveSuccess?: () => void;
};

export const EditLocalUserModal: FC<Props> = (props) => {
  const globalCtxProps = useGlobalStateContextSelectors({
    currentUserId: prop('auth', 'id'),
  });
  const usersMsg = useLocale().localUsers;

  const getModalTitle = () => {
    if (props.editedUser === 'new') {
      return usersMsg.newUserTitle;
    }

    if (props.editedUser.id === globalCtxProps.currentUserId) {
      return usersMsg.editCurrentUserTitle;
    }

    return usersMsg.editUserTitle.replace(
      '{username}',
      props.editedUser.username,
    );
  };

  const handleSaveSuccess = () => {
    props.onSaveSuccess?.();
    props.onClose();
  };

  return (
    <SidePanel
      closeOnBackdropClick={false}
      onClose={props.onClose}
      title={getModalTitle()}
    >
      <Card className='p'>
        {props.editedUser !== 'new' &&
        props.editedUser.id === globalCtxProps.currentUserId ? (
          <UserProfile onSaveSuccess={handleSaveSuccess} />
        ) : (
          <>
            <LocalUserForm
              editedUser={props.editedUser}
              onSaveSuccess={handleSaveSuccess}
            />
            {props.editedUser !== 'new' && props.editedUser.isLocal && (
              // onSaveSuccess is not propagated there intentionally - password
              // change does not affect table content.
              <UpdatePasswordForm
                className='mt-12'
                editedUserId={props.editedUser.id}
              />
            )}
          </>
        )}
      </Card>
    </SidePanel>
  );
};
